// TODO: Merge with TagIds file(s)
enum HighlightKey {
  AccidentFree = 'AccidentFree',
  GreatDeal = 'KeepMovingPrice',
  PriceDrop = 'RecentPriceDrop',
  RecentlyAdded = 'RecentlyAdded'
}

export default HighlightKey;
